import { Grid, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { AccountInstitutionType, PendingAccount } from './types';

export interface AccountDetailProps {
  account: PendingAccount;
  isSuperSimplifier?: boolean;
}

const useStyles = makeStyles(() => ({
  rootDiv: {
    width: '100%',
    textAlign: 'left',
  },
  iconImage: {
    height: '30px',
    margin: '0 auto',
  },
  bsb: {
    paddingRight: '20px',
  },
}));

export const PendingAccountDetail = ({ account, isSuperSimplifier }: AccountDetailProps): JSX.Element => {
  const classes = useStyles();
  const institution = AccountInstitutionType.getById(account.institutionId);

  return (
    <div className={classes.rootDiv}>
      <Grid container spacing={2}>
        <Grid container item xs={3} alignContent={'center'}>
          <Tooltip title={institution?.displayName ?? ''} arrow>
            <img src={institution?.getLogo()} alt="Institution" className={classes.iconImage} />
          </Tooltip>
        </Grid>
        <Grid container item xs={9}>
          <Grid container>
            <Grid item xs={12}>
              {!!account.name && (
                <Typography variant="h5" style={{ fontWeight: 700 }}>
                  {account.name}
                </Typography>
              )}
              {!account.name && (
                <Typography variant="h5" style={{ fontWeight: 700 }}>
                  {institution?.displayName}
                </Typography>
              )}
            </Grid>

            {!!account.bsb && (
              <Typography variant="h5" className={classes.bsb}>
                BSB: {account.bsb}
              </Typography>
            )}
            {!!account.number && (
              <Typography variant="h5">
                {isSuperSimplifier ? 'Super member' : 'Account'} number: {account.number}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
